const getDomain = (envType : string | undefined) => {
    switch (envType) {
        case "dev":
            return "https://donmagnate.backend.wtsdemo.ru/api"
        default:
            return "http://localhost:7070/api"
    }
}

export const domainUrl = getDomain(process.env.REACT_APP_STATUS)